const colNameRegex = /\(([^)]+)\)/;
function parseColName(colName) {
    const newName = colNameRegex.exec(colName);
    return newName ? newName[1].replace(/_/g, ' ') : colName;
}
function csvStringToArrays(csvString) {
    if (csvString) {
        const table = csvString
            .trim()
            .split('\n')
            .map((line) => line.trim().split(/,(?=(?:[^\"]*\"[^\"]*\")*(?![^\"]*\"))/));
        const withNumbers = table.map((row) => row.map((cell) => {
            const parsedCell = parseFloat(cell);
            return parsedCell || cell;
        }));
        return withNumbers;
    }
    return csvString;
}
function roundCellNumber(possibleNumber, decimalPoints = 2) {
    const cellInt = parseFloat(possibleNumber);
    if (cellInt) {
        const decQuoc = 10 ** decimalPoints;
        return Math.floor(cellInt * decQuoc) / decQuoc;
    }
    return possibleNumber;
}
function getTableQuocient(table) {
    const allValues = new Set();
    table.forEach((line) => line.forEach((cell) => {
        const cellInt = parseFloat(cell);
        if (cellInt) {
            allValues.add(cellInt);
        }
    }));
    const sortedValues = [...allValues].sort((a, b) => parseFloat(a) - parseFloat(b));
    return sortedValues;
}
function getValuesTest(table) {
    const output = [[]];
    table.splice(1).forEach((element, index) => {
        output[0].push((element + '').split(',', 1));
        output.push([]);
        (element + '')
            .split(',')
            .splice(1)
            .forEach((el, i) => {
            if (table[0][i + 1].includes('sum(')) {
                output[index + 1].push({
                    name: table[0][i + 1].replace('sum(', '').replace(')', '').replace(/[__]/g, ' '),
                    value: parseFloat(el)
                });
            }
        });
    });
    output.splice(1).forEach((element, index) => {
        output[index + 1] = element.sort((a, b) => (a.value > b.value ? 1 : -1)).reverse();
    });
    return output;
}
function getOtherTest(table, cell) {
    const output = [];
    table.slice(1).forEach((elem) => {
        let found = false;
        for (var i = 0; i < elem.length; i++) {
            if (elem[i].name === cell.name) {
                found = true;
                break;
            }
        }
        if (found) {
            output.push(elem[i]);
        }
        else {
            output.push('NAN');
        }
    });
    return output;
}
export { parseColName, roundCellNumber, csvStringToArrays, getTableQuocient, getValuesTest, getOtherTest };
